import { closeSubmenus } from './menu'

const initSearchBar = () => {
    const openSearchBar = document.querySelector('.searchbar-js-open')
    const closeSearchBar = document.querySelector('.searchbar-js-close')
    const searchBar = document.querySelector('.searchbar-js')

    openSearchBar.addEventListener('click', () => {
        searchBar.classList.toggle('opened')
        openSearchBar.classList.toggle('active')
        closeSubmenus()
    })

    closeSearchBar.addEventListener('click', () => {
        searchBar.classList.remove('opened')
        openSearchBar.classList.toggle('active')
    })
}

export { initSearchBar }